module.exports = __webpack_public_path__ + "img/infestsmall.51a3a4a3.jpg";